var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUzs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5871)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335H23V23.0002H0V15.3335Z",
    fill: "#14DC5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V9.58333H0V0Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.4375 9.2085H-1.8125V9.5835V15.3335V15.7085H-1.4375H24.4375H24.8125V15.3335V9.5835V9.2085H24.4375H-1.4375Z",
    fill: "#F7FCFF",
    stroke: "#C51918",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0228 2.30081L11.3165 2.83506L11.5182 1.74925L10.8416 0.951346H11.7253L12.0217 -0.0761719L12.3693 0.951346H13.1226L12.5307 1.74925L12.8153 2.83506L12.0228 2.30081ZM8.40185 5.24708L9.10816 4.71282L9.90067 5.24708L9.61606 4.16126L10.208 3.36336H9.45463L9.10709 2.33584L8.8107 3.36336H7.92699L8.60358 4.16126L8.40185 5.24708ZM6.45189 7.2384L5.74558 7.77266L5.94731 6.68684L5.27072 5.88894H6.15443L6.45082 4.86142L6.79836 5.88894H7.55171L6.95979 6.68684L7.2444 7.77266L6.45189 7.2384ZM9.14883 7.24257L8.44253 7.77682L8.64425 6.69101L7.96767 5.89311H8.85138L9.14777 4.86559L9.49531 5.89311H10.2487L9.65673 6.69101L9.94134 7.77682L9.14883 7.24257ZM12.0238 7.24257L11.3175 7.77682L11.5193 6.69101L10.8427 5.89311H11.7264L12.0228 4.86559L12.3703 5.89311H13.1237L12.5317 6.69101L12.8163 7.77682L12.0238 7.24257ZM11.2769 5.24708L11.9832 4.71282L12.7757 5.24708L12.4911 4.16126L13.083 3.36336H12.3296L11.9821 2.33584L11.6857 3.36336H10.802L11.4786 4.16126L11.2769 5.24708ZM14.1925 7.77682L14.8988 7.24257L15.6913 7.77682L15.4067 6.69101L15.9986 5.89311H15.2453L14.8978 4.86559L14.6014 5.89311H13.7177L14.3943 6.69101L14.1925 7.77682ZM14.8582 4.71282L14.1519 5.24708L14.3536 4.16126L13.677 3.36336H14.5607L14.8571 2.33584L15.2046 3.36336H15.958L15.3661 4.16126L15.6507 5.24708L14.8582 4.71282ZM14.1915 2.83506L14.8978 2.30081L15.6903 2.83506L15.4057 1.74925L15.9976 0.951346H15.2443L14.8967 -0.0761719L14.6003 0.951346H13.7166L14.3932 1.74925L14.1915 2.83506ZM17.7738 7.24257L17.0675 7.77682L17.2692 6.69101L16.5927 5.89311H17.4764L17.7728 4.86559L18.1203 5.89311H18.8736L18.2817 6.69101L18.5663 7.77682L17.7738 7.24257ZM17.0269 5.24708L17.7332 4.71282L18.5257 5.24708L18.2411 4.16126L18.833 3.36336H18.0796L17.7321 2.33584L17.4357 3.36336H16.552L17.2286 4.16126L17.0269 5.24708ZM17.7728 2.30081L17.0665 2.83506L17.2682 1.74925L16.5916 0.951346H17.4753L17.7717 -0.0761719L18.1193 0.951346H18.8726L18.2807 1.74925L18.5653 2.83506L17.7728 2.30081ZM4.22978 7.89719C4.22978 7.89719 2.49339 7.26926 2.52608 4.94676C2.55878 2.62425 4.3125 2.02126 4.3125 2.02126C3.59593 1.65945 1.47714 2.14494 1.43802 4.92321C1.39891 7.70148 3.56207 8.2488 4.22978 7.89719Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5871)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5871",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzs);
export default __webpack_public_path__ + "static/media/UZS.9ca972328ecc13e5f05e8683e6e62d29.svg";
export { ForwardRef as ReactComponent };